import { IndustryCatalogType, Pagination } from '@core/shared/domain';

import {
  AssignedIndustryCatalogSearchQueryField,
  PlatformcatalogSearchQueryField,
} from './platformcatalog-search-query-field';

export const DEFAULT_PAGINATION: Pagination = { page: 1, pageSize: 10 };

export type MarkPublishFilter = {
  catalogType?: Array<IndustryCatalogType>;
  searchTerm?: string;
};

/**
 * Filter model for the query of industry catalogs in platform catalogs.
 */
export interface AssignedIndustryCatalogFilterQueryModel extends Pagination {
  searchTerm?: string;
  field?: AssignedIndustryCatalogSearchQueryField;
  catalogType?: Array<IndustryCatalogType>;
  dataSources?: Array<string>;
  isUpdated?: boolean;
}

/**
 * Filter for platform catalogs.
 */
export interface PlatformCatalogGlobalFilter {
  searchTerm?: string;
  field?: PlatformcatalogSearchQueryField;
  catalogType?: Array<IndustryCatalogType>;
  dataSources?: Array<string>;
  updatedOnly?: boolean;
}

/**
 * Filter for industry catalogs in platform catalogs. Is stored by each platform catalog.
 */
export type PlatformIndustryCatalogFilter = Pagination;

/**
 * Combined filter parameters for platform catalog URLs.
 */
export type PlatformCatalogFilter = PlatformCatalogGlobalFilter & PlatformIndustryCatalogFilter;
